import { Link } from 'react-router-dom';

interface Props {
  slug: string;
  category: string;
  title: string;
  brief: string;
  cover: string;
  eager?: boolean;
}

export default function WorkCard({ slug, category, title, brief, cover, eager }: Props) {
  return (
    <article data-fade>
      <Link to={`/work/${slug}`} className="group flex flex-col h-full cursor-pointer focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent-500 focus-visible:outline-offset-4">
        <div className="w-full aspect-[16/10] overflow-hidden bg-background-200">
          <img src={cover} alt={`${title} — illustrative engagement`} title={title} loading={eager ? 'eager' : 'lazy'} className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-[1.03]" />
        </div>
        <span className="label-xs text-foreground-600 mt-5">{category}</span>
        <div className="flex items-start justify-between gap-6 mt-2.5 flex-1">
          <div>
            <h2 className="font-heading font-light uppercase tracking-[0.04em] leading-[1.2] text-[21px] md:text-[23px] text-foreground-950 group-hover:text-primary-500 transition-colors">{title}</h2>
            <p className="mt-2.5 text-[15px] leading-[1.6] text-foreground-700 max-w-[360px]">{brief}</p>
          </div>
          <span className="circle-arrow inv-dark text-foreground-950 mt-1"><i className="ri-arrow-right-up-line" /></span>
        </div>
      </Link>
    </article>
  );
}